import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col, Table } from "reactstrap";
import axios from "axios";
import moment from "moment";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import ImportarGastosModal from "../../../ImportarGastosModal";

function GastosGeneralCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_GASTOS_GENERAL = process.env.REACT_APP_URL_GASTOS_GENERAL;
  // const URL_CONCEPTOS_GASTOS = process.env.REACT_APP_URL_CONCEPTOS_GASTOS;
  const URL_CATEGORIAS = process.env.REACT_APP_URL_CATEGORIAS;
  const URL_SUB_CATEGORIAS = process.env.REACT_APP_URL_SUB_CATEGORIAS;
  const URL_SOLICITANTES = process.env.REACT_APP_URL_SOLICITANTES;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [fecha, setFecha] = useState(hoy);
  const [subtotal, setSubtotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total, setTotal] = useState(0);
  const [descripcion, setDescripcion] = useState("NA");
  // const [conceptosGastos, setConceptosGastos] = useState([]);
  // const [selectedConcepto, setSelectedConcepto] = useState("");
  const [categorias, setCategorias] = useState([]);
  const [selectedCategoria, setSelectedCategoria] = useState("");
  const [subCategorias, setSubCategorias] = useState([]);
  const [selectedSubCategoria, setSelectedSubCategoria] = useState("");
  const [solicitantes, setSolicitantes] = useState([]);
  const [selectedSolicitante, setSelectedSolicitante] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [selectedImpuesto, setSelectedImpuesto] = useState(0);

  const [selectedBanco, setSelectedBanco] = useState("");
  const [bancos, setBancos] = useState([]);
  const [moneda, setMoneda] = useState("");
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);
  const [modalImportar, setModalImportar] = useState(false);
  // Nómina: un renglón por colaborador con su sueldo registrado (editable)
  const [nomina, setNomina] = useState([]);

  // La categoría "Nómina" se captura distinto: se jala a los colaboradores
  // y se guarda un gasto por cada uno.
  const esNomina = /n[oó]mina/i.test(
    categorias.find((c) => c._id === selectedCategoria)?.name || ""
  );

  useEffect(() => {
    if (!esNomina) return;
    // Si la categoría tiene una sola subcategoría ya no hay nada que elegir
    const subs = subCategorias.filter((s) => s.categorias[0]?._id === selectedCategoria);
    if (subs.length === 1) setSelectedSubCategoria(subs[0]._id);
    if (nomina.length) return;
    axios
      .get(URL_COLABORADORES, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        const renglones = (res.data || [])
          .filter((c) => c.is_active !== "No")
          .map((c) => {
            const sueldo = Number(c.sueldo_actual) || 0;
            return {
              _id: c._id,
              nombre: `${c.nombre || ""} ${c.apellido || ""}`.trim(),
              frecuencia: c.frecuencia || "",
              sueldo,
              monto: sueldo,
              incluir: sueldo > 0,
            };
          })
          .sort((a, b) => a.nombre.localeCompare(b.nombre));
        setNomina(renglones);
      })
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [esNomina, subCategorias]);

  const cambiaNomina = (id, cambios) =>
    setNomina((prev) => prev.map((n) => (n._id === id ? { ...n, ...cambios } : n)));
  const totalNomina = nomina
    .filter((n) => n.incluir)
    .reduce((t, n) => t + (Number(n.monto) || 0), 0);
  const dinero = (n) =>
    new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);

  useEffect(() => {
    // axios
    //   .get(URL_CONCEPTOS_GASTOS, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allConceptosGastos = res.data;
    //     setConceptosGastos(allConceptosGastos);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

      axios
        .get(URL_CATEGORIAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allCategorias = res.data;
          setCategorias(allCategorias);
        })
        .catch((err) => {
          console.log(err);
        });

        axios
        .get(URL_SUB_CATEGORIAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allSubCategorias = res.data;
          setSubCategorias(allSubCategorias);
        })
        .catch((err) => {
          console.log(err);
        });
        
      axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allEmpresas = res.data;
        setEmpresas(allEmpresas);
      })
      .catch((err) => {
        console.log(err);
      })
      axios
      .get(URL_SOLICITANTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allSolicitantes = res.data;
        setSolicitantes(allSolicitantes);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });

    }, []);

    function jalaBanco(e) {
      setSelectedBanco(e);
      bancos.map((a) => {
        if (a._id == e) {
          return setMoneda(a.moneda);
        }
      });
    }

    const calcula = (e) => {
      setIva(e * (selectedImpuesto / 100))
      setSubtotal(e);
      setTotal(parseFloat(e) + parseFloat(e * (selectedImpuesto / 100)));
    };
  
    const calculaIVA = (e) => {
      setSelectedImpuesto(e)
      setIva(subtotal * (e / 100));
      setTotal(parseFloat(subtotal) + parseFloat(subtotal * (e / 100)));
    };

  // Nómina: un gasto (y su movimiento de banco) por colaborador, sin IVA
  const saveNomina = async () => {
    const renglones = nomina.filter((n) => n.incluir && Number(n.monto) > 0);
    if (!renglones.length) {
      return Swal.fire({ icon: "warning", title: "No hay a quién pagar", text: "Marca al menos un colaborador con monto." });
    }
    const ok = await Swal.fire({
      title: "¿Guardar la nómina?",
      text: `${renglones.length} gastos por ${dinero(totalNomina)}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si, guardar",
    });
    if (!(ok.isConfirmed || ok.value)) return;
    setValidaBoton(false);
    const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    let guardados = 0;
    let sinMovimiento = "";
    try {
      for (const n of renglones) {
        const monto = Math.round((Number(n.monto) || 0) * 100) / 100;
        const { data } = await axios.post(
          URL_GASTOS_GENERAL,
          {
            is_active: "Si",
            fecha,
            subtotal: monto,
            iva: 0,
            total: monto,
            descripcion: `${descripcion && descripcion !== "NA" ? descripcion : "Nómina"} - ${n.nombre}`,
            areas: AREAS_GENERAL,
            categorias: selectedCategoria,
            subCategorias: selectedSubCategoria,
            solicitantes: selectedSolicitante,
            bancos: selectedBanco,
            empresas: selectedEmpresa,
            colaboradores: n._id,
          },
          headers
        );
        // Ya tiene gasto: se desmarca para que un reintento no le pague doble
        cambiaNomina(n._id, { incluir: false });
        sinMovimiento = n.nombre;
        await axios.post(
          URL_MOVIMIENTOS_BANCOS,
          { fecha, importe: -monto, tipo: "Egreso", bancos: selectedBanco, gastosGeneral: data._id, moneda, tipoCambio: 1 },
          headers
        );
        sinMovimiento = "";
        guardados++;
      }
      await axios.post(
        URL_LOGS,
        {
          tipo: "Crear Gasto Nómina",
          detalle: `Fecha: ${fecha} / ${guardados} colaboradores / Total: ${totalNomina}`,
          user: user.id,
        },
        headers
      );
      await Swal.fire("Listo", `Se guardaron ${guardados} gastos de nómina`, "success");
      window.location.reload();
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "No se terminó de guardar",
        text: `Se guardaron ${guardados} de ${renglones.length}. ${
          sinMovimiento ? `El gasto de ${sinMovimiento} quedó sin movimiento de banco; revísalo antes de seguir. ` : ""
        }${error?.response?.data?.message || ""}`,
      });
      setValidaBoton(true);
    }
  };

  const saveGasto = (event) => {
    event.preventDefault();
    // El "Selecciona" (value "0") pasa el required del navegador, y sin estos
    // datos el back rechaza el gasto o el listado ya no lo puede pintar
    const faltan = [
      [selectedEmpresa, "Empresa"],
      [selectedBanco, "Banco"],
      [selectedCategoria, "Categoría"],
      [selectedSubCategoria, "SubCategoría"],
      [selectedSolicitante, "Solicitó / Autorizó"],
    ]
      .filter(([v]) => !v || v === "0")
      .map(([, nombre]) => nombre);
    if (faltan.length) {
      return Swal.fire({ icon: "warning", title: "Falta información", text: `Elige: ${faltan.join(", ")}` });
    }
    if (esNomina) return saveNomina();
    setValidaBoton(false);
        axios.post(
          URL_GASTOS_GENERAL,
          {
            is_active:"Si",
            fecha,
            subtotal,
            iva,
            total,
            descripcion,
            areas: AREAS_GENERAL,
            // conceptosGastos:selectedConcepto,
            categorias: selectedCategoria,
            subCategorias: selectedSubCategoria,
            solicitantes: selectedSolicitante,
            bancos: selectedBanco,
            empresas: selectedEmpresa,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      .then((data) => {

        axios
        .post(
        `${URL_MOVIMIENTOS_BANCOS}`,
        {
            fecha,
            importe: -total,
            tipo:"Egreso",
            bancos: selectedBanco,
            gastosGeneral:data.data._id,
            moneda,
            tipoCambio:1
        },
        {
            headers: {
            Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
            )}`,
            },
        }
        )

        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Gasto",
            detalle: `Fecha: ${fecha} / Solicitante: ${selectedSolicitante} / Total: ${total} `,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
        setValidaBoton(true);
      });
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_gastos ? (
        <div className="container">
          <div className="card container col-sm-8">
            <h3 align="center">Nuevo Gasto</h3>
            <div style={{ textAlign: "right", marginBottom: 8 }}>
              <Button size="sm" color="info" onClick={() => setModalImportar(true)}>
                <i className="far fa-file-excel"></i> Carga masiva (layout)
              </Button>
            </div>
            <Form onSubmit={saveGasto}>
              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                <Row>
                <Col md={6}>
              <Label>Empresa</Label>
                <Input
                  type="select"
                  value={selectedEmpresa}
                  required
                  onChange={(e) => {
                    setSelectedEmpresa(e.target.value);
                  }}
                >
                  <option value="0">Selecciona una Empresa</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>

                <Col md={6}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Fecha
                    </Label>
                    <Input
                      type="date"
                      placeholder="Fecha"
                      value={fecha}
                      required
                      onChange={(e) => {
                        setFecha(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row>

                  <Col md={6}>
                  <Label className="mr-sm-2">Banco</Label>
                  <Input
                    type="select"
                    value={selectedBanco}
                    onChange={(e) => {
                      jalaBanco(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Banco</option>
                    {bancos
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.banco} {a.cuenta}
                          </option>
                        );
                      })}
                  </Input>
                </Col>
                  <Col md={6}>
                    <Label className="mr-sm-2">Categoria</Label>
                      <Input
                        // bsSize="sm"
                        type="select"
                        required
                        value={selectedCategoria}
                        onChange={(e) => setSelectedCategoria(e.target.value)}
                      >
                        <option value="0">Selecciona</option>
                        {categorias
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                              return <option value={a._id}>{a.name}</option>;
                          })}
                      </Input>
                      </Col>

                  </Row>
                  <Row>

                      <Col md={6}>
                    <Label className="mr-sm-2">SubCategoria</Label>
                      <Input
                        // bsSize="sm"
                        type="select"
                        required
                        value={selectedSubCategoria}
                        onChange={(e) => setSelectedSubCategoria(e.target.value)}
                      >
                        <option value="0">Selecciona</option>
                        {subCategorias
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                            if(a.categorias[0]._id == selectedCategoria)
                              return <option value={a._id}>{a.name}</option>
                          })}
                      </Input>
                      </Col>
                <Col md={6}>
                    <Label className="mr-sm-2">Solicito / Autorizo</Label>
                      <Input
                        // bsSize="sm"
                        type="select"
                        required
                        value={selectedSolicitante}
                        onChange={(e) => setSelectedSolicitante(e.target.value)}
                      >
                        <option value="0">Selecciona</option>
                        {solicitantes
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                              return <option value={a._id}>{a.name}</option>;
                          })}
                      </Input>
                      </Col>

                      </Row>
                  <Row>
               
                  <Col md={6}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Descripcion
                    </Label>
                    <Input
                      type="text"
                      placeholder="Descripcion"
                      value={descripcion}
                      required
                      onChange={(e) => {
                        setDescripcion(e.target.value);
                      }}
                    />
                  </Col>

                  {!esNomina ? (
                  <Col md={6}>
                <Label>Impuestos</Label>
                <Input
                  type="select"
                  value={selectedImpuesto}
                  onChange={(e) => {
                    calculaIVA(e.target.value);
                  }}
                >
                  <option value={0}>No</option>
                  <option value={16}>Si</option>
                </Input>
              </Col>
                  ) : null}
                </Row>

                {esNomina ? (
                  <>
                    <div style={{ fontSize: 13, color: "#555", margin: "12px 0 6px" }}>
                      Se guarda <b>un gasto por colaborador</b> con su sueldo registrado; puedes cambiar el monto o
                      quitar a quien no se le paga. La nómina no lleva IVA.
                    </div>
                    <Table size="sm" striped bordered>
                      <thead>
                        <tr>
                          <th>Pagar</th>
                          <th>Colaborador</th>
                          <th>Frecuencia</th>
                          <th style={{ textAlign: "right" }}>Sueldo registrado</th>
                          <th style={{ textAlign: "right" }}>Monto a pagar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {nomina.map((n) => (
                          <tr key={n._id}>
                            <td align="center">
                              <input
                                type="checkbox"
                                checked={n.incluir}
                                onChange={(e) => cambiaNomina(n._id, { incluir: e.target.checked })}
                              />
                            </td>
                            <td>{n.nombre}</td>
                            <td>{n.frecuencia}</td>
                            <td align="right">{dinero(n.sueldo)}</td>
                            <td align="right">
                              <Input
                                bsSize="sm"
                                type="number"
                                min="0"
                                step="any"
                                style={{ width: 130, display: "inline-block" }}
                                value={n.monto}
                                disabled={!n.incluir}
                                onChange={(e) => cambiaNomina(n._id, { monto: e.target.value })}
                              />
                            </td>
                          </tr>
                        ))}
                        <tr style={{ fontWeight: "bold" }}>
                          <td colSpan={4} align="right">
                            Total ({nomina.filter((n) => n.incluir && Number(n.monto) > 0).length} colaboradores)
                          </td>
                          <td align="right">{dinero(totalNomina)}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </>
                ) : (
                <Row>
                  <Col sm={4}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Subtotal
                    </Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Subtotal"
                      value={subtotal}
                      required
                      onChange={(e) => calcula(e.target.value)}
                    />
                  </Col>
                  <Col sm={4}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      IVA
                    </Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      placeholder="IVA"
                      value={iva}
                      required
                      disabled
                      // onChange={(e) => calculaIVA(e.target.value)}
                    />
                  </Col>
                  <Col sm={4}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Total
                    </Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      placeholder={total}
                      disabled
                    />
                  </Col>
                </Row>
                )}
              </FormGroup>
              <br />
              <Col>
                <Row>
                  {validaBoton ? (
                    <Button type="submit" className="btn btn-success">
                      Guardar
                    </Button>
                  ) : (
                    <Button type="submit" className="btn btn-success" disabled>
                      Guardar
                    </Button>
                  )}
                  <div>
                    <SweetAlert
                      show={text}
                      title="Creado con Exito"
                      onConfirm={() => {
                        setText(false);
                      }}
                    />
                  </div>
                  <Button
                    href="/Gastos"
                    className="btn btn-danger"
                    id="botonListado"
                  >
                    Regresar
                  </Button>
                </Row>
              </Col>
            </Form>
          </div>
          <ImportarGastosModal
            abierto={modalImportar}
            cerrar={() => setModalImportar(false)}
            onTerminado={() => window.location.reload()}
            userId={user.id}
          />
        </div>
      ) : undefined}
    </>
  );
}

export default GastosGeneralCreate;
